export const IMAGES = ['image/jpeg', 'image/png', 'image/webp']
export const VIDEOS = ['video/mp4', 'video/3gpp']
export const AUDIOS = ['audio/acc', 'audio/aac', 'audio/mp4', 'audio/amr', 'audio/mpeg', 'audio/mp3']

export const isImage = ({ fileMimeType }) => (
  IMAGES.includes(fileMimeType)
)

export const isAudioType = ({ fileMimeType, codec }) => {
  if (AUDIOS.includes(fileMimeType)) return true
  if (String(fileMimeType || '').includes('audio/ogg') && String(codec || '').toLowerCase().includes('opus')) return true
  return false
}

export const isVideoType = ({ fileMimeType }) => (
  VIDEOS.includes(fileMimeType)
)

export const TYPES_MESSAGE = {
  TEXT: 'TEXT',
  IMAGE: 'IMAGE',
  AUDIO: 'AUDIO',
  DOC: 'DOC',
  CONTACT: 'CONTACT',
  VIDEO: 'VIDEO',
  LOCALIZATION: 'LOCALIZATION'
}

export const TWILIO_MIME_TYPES = ['image/jpeg', 'image/png', 'audio/mpeg', 'audio/ogg', 'application/pdf', 'video/mp4', 'text/x-vcard']
